function Simulator(options) {
    this._checkOptions(options);
}

// abstract method to override
Simulator.prototype.load = function () {
};

Simulator.prototype._checkOptions = function (options) {
    if (!options) {
        throw new Error("Simulator - missing constructor options parameter");
    }

    var expectedParameters = ["element", "sdcWrapper", "defaultRoute", "noRoute"];

    for (var i = 0; i < expectedParameters.length; i++) {
        if (!options[expectedParameters[i]]) {
            throw new Error(
                "Simulator - missing options parameter:",
                expectedParameters[i]
            );
        }
    }

    this.element = options.element;
    this.options = {};
    this.options.sdcWrapper = options.sdcWrapper;
    this.options.defaultRoute = options.defaultRoute;
    this.options.noRoute = options.noRoute;
};

export default Simulator;



// WEBPACK FOOTER //
// ./src/js/cms/deprecated/simulators/Simulator.js